RivalIQ.module('data', function (data, App, Backbone, Marionette, $, _) {

    'use strict';

    const AdminInvoices = RivalIQ.data.CacheLayer.extend({
        name: 'AdminInvoices',
        cacheKeys: [
            'account_id'
        ],

        loadData: function (attrs) {
            const invoices = new RivalIQ.apps.Admin.collections.Invoices(attrs);

            return invoices.fetch().then(function () {
                return invoices;
            });
        },

        fetch: function (account_id) {
            const me = this;

            return me.getOrLoad({
                account_id: account_id
            });
        }
    });

    data.adminInvoices = new AdminInvoices();
});
